import type {
  RouteLocation,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import {
  PATH_DTWINS,
  PATH_DTWINS_ID,
  PATH_DTWINS_ID_ADDITIONAL_METADATA,
  PATH_DTWINS_ID_CERTIFICATE,
  PATH_DTWINS_ID_CERTIFICATE_OPERATION_UID_STEPS,
  PATH_DTWINS_ID_CONFIGURATION,
  PATH_DTWINS_ID_CONFIGURATION_OPERATION_UID_STEPS,
  PATH_DTWINS_ID_DATA_VISUALISATION,
  PATH_DTWINS_ID_DESCRIPTION,
  PATH_DTWINS_ID_FIRMWARE,
  PATH_DTWINS_ID_FIRMWARE_OPERATION_UID_STEPS,
  PATH_DTWINS_ID_LOGS,
  PATH_DTWINS_ID_MODULES,
} from "~/modules/dtwin/constants";
import { router } from "~/plugins/router";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_DTWINS,
    component: () => import("~/modules/dtwin/views/DtwinsPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    // The dtwin page does not exist by itself, it is a wrapper for the dtwin tabs. The navigation to this page (via the
    // left panel or the URL) must redirect to the description tab.
    path: PATH_DTWINS_ID,
    redirect: (to: RouteLocation) =>
      router.resolve({
        name: PATH_DTWINS_ID_DESCRIPTION,
        params: { id: to.params.id },
      }),
  },
  {
    path: PATH_DTWINS_ID_DESCRIPTION,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_CERTIFICATE,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_CERTIFICATE_OPERATION_UID_STEPS,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
    },
  },
  {
    path: PATH_DTWINS_ID_FIRMWARE,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_FIRMWARE_OPERATION_UID_STEPS,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
    },
  },
  {
    path: PATH_DTWINS_ID_CONFIGURATION,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_CONFIGURATION_OPERATION_UID_STEPS,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
    },
  },
  {
    path: PATH_DTWINS_ID_MODULES,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_DATA_VISUALISATION,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_ADDITIONAL_METADATA,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_LOGS,
    component: () => import("~/modules/dtwin/views/DtwinPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
];

export default routes;
